<template>
  <div class="panel">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "index"
  }
</script>

<style scoped>
  .panel {
    background: rgba(24, 144, 255, 0.7);
    box-shadow: 0 1px 3px 0 rgba(24, 144, 255, .12), 0 0 3px 0 rgba(24, 144, 255, .04);
    border-radius: 8px;
    padding: 12px 15px;
    font-size: 16px;
    color: #fff;
    font-family: PingFang HK;
  }
</style>
